import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Form, Nav, ProgressBar } from 'react-bootstrap';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import IconButton from 'componentes/common/IconButton.js';
import ExpedienteData from './_ExpedienteData.js';
import QuejaData from './_QuejaData.js';
import ConsumidorData from './_ConsumidorData.js';
import ExtraData from './_ExtraData.js';
import { useQuejaWizardContext } from 'context/QuejaWizardProvider.js';
import { NavItem } from 'componentes/wizard/WizardNavItem.js';
import ProductoData from './_ProductoData.js';
import { httpClient } from 'helpers/HttpClient.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { useAuth } from 'context/AuthProvider.js';
import NotificationAlert from 'componentes/generic/Notification.js';
import { FormatDateToDb } from 'helpers/FormatData.js';
import { isNullOrEmpty } from 'helpers/utils.js';

const URI = ApiEndpoint + 'operations/';
const NewQuejaWizard = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [loading, setLoading] = useState(false);

  const [errorMesagge, setErrorMesagge] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [isError, setIsError] = useState(false);
  const { queja, setQueja, step, setStep } = useQuejaWizardContext();
  const {
    register,
    handleSubmit,
    trigger,
    formState: { errors },
    watch,
    control,
    setValue
  } = useForm({
    defaultValues: {
      fecharecepcion: new Date(),
      fechaqueja: new Date(),
      montopagado: '',
      montoreal: '',
      telefono2: '',
      anio: new Date().getFullYear().toString(),
      statusFacturacion: 11,
      expedienteTipo: 'PFC',
      expedienteUbi: 'B',
      expedienteClave: 'B',
      expedienteId: '3',
      expediente: ''
    }
  });
  const navItems = [
    {
      icon: 'lock',
      label: 'Expediente'
    },
    {
      icon: 'user',
      label: 'Consumidor'
    },
    {
      icon: 'user',
      label: 'Producto'
    },
    {
      icon: 'dollar-sign',
      label: 'Queja'
    },
    {
      icon: 'thumbs-up',
      label: 'Listo'
    }
  ];

  const onSubmitData = data => {
    console.log(data);
    if (loading) return; // prevent double submit
    setLoading(true);

    setQueja({ ...queja, ...data });
    let expedienteFolio =
      data.expedienteTipo +
      '.' +
      data.expedienteUbi +
      '.' +
      data.expedienteClave +
      '.' +
      data.expedienteId +
      '.' +
      data.expediente;
    let newQueja = {
      recepcionQueja: {
        numeroqueja: expedienteFolio.replaceAll('_', ''),
        fecharecepcionjmm: data.fecharecepcion,
        fechaqueja: data.fechaqueja,
        iddeterminante: data.determinante,
        iddelegacion: data.delegacion,
        idtipoproducto: data.tipoproducto,
        idclasificacionqueja: data.clasificacionQueja,
        nombreconsumidor: data.nombre,
        idstatusgenero: data.genero,
        lada: '',
        tel1: data.telefono,
        email: data.email,
        tel2: '',
        motivoqueja: '', // data.descripcionqueja,
        idstatusfacturacion: data.statusFacturacion,
        idstatus: 12,
        idclienteresponsable: data.cliente,
        montopagado: data.montopagado,
        montoreal: data.montoreal,
        tipoplataforma: data.tipoPlataforma,
        formatoqueja: data.formatoqueja,
        anio: data.anio,
        numeropedido: data.numeropedido,
        idtipoevento: data.idtipoevento,
        idclasificacionquejawm: data.clasificacionQuejawm,
        idclasificacionquejaprofeco: data.clasificacionQuejaProfeco
      },
      quejaDetalle: {
        descripcionwm: data.descripcionwalmart,
        oportunidad: isNullOrEmpty(data.oportunidad)
          ? 'Regular'
          : data.oportunidad,
        fechaoportunidad: data.fechaoportunidad,
        expedientepil: data.expedientepil,
        folioext: data.folioext,
        preconciliacion: data.preconciliacion,
        fechadevolucion: data.fechadevolucion,
        fechacompra: data.fechacompra,
        seller: data.seller
      },
      seguimiento: {
        fecha: FormatDateToDb(data.fechaaudiencia),
        minute: data.fechaaudiencia.getMinutes(),
        hour: data.fechaaudiencia.getHours(),
        espresencial: data.espresencial
      }
    };
    console.log('newQueja', newQueja);

    // setStep(step + 1);
    httpClient('POST', URI + 'createqueja', newQueja, userData.token)
      .then(function (response) {
        console.log(response.data);
        if (!response.data.error) {
          //Notify
          setIsError(false);
          setErrorMesagge('Queja creada exitosamente');
          setShowErrorMessage(true);
          let path = `/`;
          window.location.href = path;
        } else {
          setIsError(true);
          setErrorMesagge('Ha Ocurrido un error');
          setShowErrorMessage(true);
          setLoading(false); // re-enable after done
        }
      })
      .catch(function (error) {
        setIsError(true);
        setErrorMesagge('Ha Ocurrido un error');
        setShowErrorMessage(true);
        setLoading(false); // re-enable after done
        console.log(error);
      })
      .finally(() => {});
  };
  const onError = error => {
    console.log(error);
  };

  const handleNavs = targetStep => {
    if (step !== 5) {
      if (targetStep < step) {
        setStep(targetStep);
      }
    }
  };
  const stepFields = [
    [
      'expediente',
      'preconciliacion',
      'delegacion',
      'cliente',
      'subcustomer',
      'determinante',
      'idtipoevento'
    ], // Fields to validate in step 0
    ['nombre', 'genero', 'email', 'telefono'], // Fields to validate in step 1
    [
      'numeropedido',
      'tipoPlataforma',
      'statusFacturacion',
      'tipoproducto',
      'montopagado',
      'montoreal'
    ], // Step 2
    [
      'clasificacionQueja',
      'clasificacionQuejawm',
      'idclasificacionquejaprofeco',
      'fechaqueja',
      'fecharecepcion',
      'formatoqueja',
      'anio',
      'descripcionqueja',
      'descripcionwalmart'
    ], // Step 2
    [
      'oportunidad',
      'fechaoportunidad',
      'expedientepil',
      'fechaaudiencia',
      'espresencial'
    ]
  ];
  const onChangeValue = event => {
    setValue(event.target.name, event.target.value);
    setQueja({ ...queja, [event.target.name]: event.target.value });
  };

  return (
    <>
      <Card
        as={Form}
        noValidate
        onSubmit={handleSubmit(onSubmitData, onError)}
        className="theme-wizard mb-5"
      >
        <Card.Header className={classNames('bg-body-tertiary', 'px-4 py-3')}>
          <Nav className="justify-content-center">
            {navItems.map((item, index) => (
              <NavItem
                key={item.label}
                index={index + 1}
                step={step}
                handleNavs={handleNavs}
                icon={item.icon}
                label={item.label}
                maxStep={navItems.length}
              />
            ))}
          </Nav>
        </Card.Header>
        <ProgressBar now={step * 20} style={{ height: 2 }} />
        <Card.Body className="fw-normal px-md-6 py-4">
          {step === 1 && (
            <ExpedienteData
              setValue={setValue}
              register={register}
              errors={errors}
              watch={watch}
              control={control}
              onChange={onChangeValue}
            />
          )}
          {step === 2 && (
            <ConsumidorData
              setValue={setValue}
              register={register}
              errors={errors}
              watch={watch}
            />
          )}
          {step === 3 && (
            <ProductoData
              setValue={setValue}
              register={register}
              errors={errors}
              watch={watch}
            />
          )}
          {step === 4 && (
            <QuejaData
              setValue={setValue}
              register={register}
              errors={errors}
              watch={watch}
              control={control}
              onChange={onChangeValue}
            />
          )}
          {step === 5 && (
            <ExtraData
              setValue={setValue}
              register={register}
              errors={errors}
              watch={watch}
              loading={loading}
            />
          )}
        </Card.Body>
        <Card.Footer
          className={classNames('px-md-6 bg-body-tertiary', {
            'd-none': step === 6,
            ' d-flex': step < 6
          })}
        >
          <IconButton
            variant="link"
            icon={'chevron-left'}
            iconAlign="left"
            transform="down-1 shrink-4"
            className={classNames('px-0 fw-semibold', {
              'd-none': step === 1
            })}
            onClick={() => {
              setStep(step - 1);
            }}
          >
            Anterior
          </IconButton>

          <IconButton
            variant="primary"
            className={classNames('ms-auto px-5', {
              'd-none': step === 5
            })}
            type="button"
            onClick={() => {
              trigger(stepFields[step - 1]).then(isValid => {
                if (isValid) {
                  setStep(step + 1);
                } else {
                  console.log('Validation failed, stay on current step');
                }
              }); // validate fields of current step
            }}
            icon={'chevron-right'}
            iconAlign="right"
            transform="down-1 shrink-4"
          >
            Siguiente
          </IconButton>
        </Card.Footer>
      </Card>
      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
        isError={isError}
      />
    </>
  );
};

NewQuejaWizard.propTypes = {
  variant: PropTypes.oneOf(['pills']),
  validation: PropTypes.bool,
  progressBar: PropTypes.bool
};

export default NewQuejaWizard;
